import React from "react";

import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { Comment } from "../../../../api/types";

export const CommentStyle = StyleSheet.create({
	container: {
		position: "absolute",
		top: 130,
		paddingLeft: 52,
		paddingRight: 53,
		flexDirection: "column",
	},
	title: {
		fontFamily: "Inter",
		fontStyle: "normal",
		fontWeight: "semibold",
		fontSize: 20,
		marginBottom: 20,
	},
	commentList: {
		flexDirection: "column",
	},
	commentContainer: {
		flexDirection: "row",
		marginBottom: 13,
		alignItems: "flex-start",
	},
	commentMetadata: {
		width: 189,
		marginLeft: 4,
		marginRight: 31,
	},
	commentMetadataRow: {
		flexDirection: "row",
	},
	commentText: {
		width: 465,
		textAlign: "justify",
	},
	commentHighlight: {
		fontFamily: "Inter",
		fontStyle: "normal",
		fontWeight: "semibold",
		fontSize: 13,
	},
	commentRegularText: {
		fontFamily: "Inter",
		fontStyle: "normal",
		fontSize: 13,
	},
});

interface CommentContentProps {
	data: Comment[];
	name: string;
}

export const CommentContent: React.FC<CommentContentProps> = ({
	data,
	name,
}): JSX.Element => (
	<View style={CommentStyle.container}>
		<Text style={CommentStyle.title}>{"Teacher's Comments"}</Text>
		{data === null && (
			<Text
				style={{
					fontFamily: "Inter",
					fontStyle: "normal",
					fontWeight: "semibold",
					fontSize: 16,
				}}
			>
				THERE IS NO RECORDED COMMENT FROM TEACHER
			</Text>
		)}
		{data && (
			<View style={CommentStyle.commentList}>
				{data.map((comment) => (
					<View key={comment.commentId} style={CommentStyle.commentContainer}>
						<View style={CommentStyle.commentMetadata}>
							<View style={CommentStyle.commentMetadataRow}>
								<Text style={CommentStyle.commentHighlight}>From: </Text>
								<Text style={CommentStyle.commentRegularText}>
									{comment.commentFrom}
								</Text>
							</View>
							<View style={CommentStyle.commentMetadataRow}>
								<Text style={CommentStyle.commentHighlight}>To: </Text>
								<Text style={CommentStyle.commentRegularText}>
									{comment.commentTo !== "" ? comment.commentTo : name}
								</Text>
							</View>
							<View style={CommentStyle.commentMetadataRow}>
								<Text style={CommentStyle.commentHighlight}>Date: </Text>
								<Text style={CommentStyle.commentRegularText}>
									{comment.date}
								</Text>
							</View>
						</View>
						<View style={CommentStyle.commentText}>
							<Text style={CommentStyle.commentRegularText}>
								{comment.comment}
							</Text>
						</View>
					</View>
				))}
			</View>
		)}
	</View>
);
